<template>
    <div :id="companyLocation.id" class="flex w-full h-28 border-b border-gray-300 text-gray-800 hover:bg-indigo-50" @mouseenter="handleRowHover" @mouseleave="handleRowLeave" :class="{ 'bg-indigo-100': pinSelected }">
        <div class="flex items-start py-3 h-full px-4" :style="rowSelectInputStyle">
            <input type="checkbox" id="checkbox" class="accent-dark-secondary cursor-pointer" :checked="isSelected" @change="toggleSelected"/>
        </div>
        <div class="font-normal cursor-pointer w-full h-full p-2" :style="rowContentStyle"  @click="selectCompanyLocation">
            <div class="pb-1">
                <span class="hover:text-accent-secondary hover:underline font-medium tracking-wider cursor-pointer" @click.exact="openCompanyModal">{{ companyName }} (ID-{{ companyId }})</span>
            </div>
            <div>{{ locationAddress }} {{ locationCity }}, {{ locationState }}, {{ locationZip }} {{ locationCountry }}</div>
            <div>Revenue: ${{ companyRevenue }} M</div>
            <div>FTE: {{ companyHeadcount }}</div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref, watch } from 'vue';

const props = defineProps(['companyLocation', 'selectedCompanyLocation', 'selectAll', 'selectedResultIds'])

const emit = defineEmits(['open-company-modal', 'select-company-location', 'select-row', 'deselect-row'])

const pinSelected = computed(() => {
    if(props.selectedCompanyLocation) {
        return props.companyLocation.id == props.selectedCompanyLocation.id ? true : false
    }
    return false
})

const rowHover = ref(false)

const rowSelectInputStyle = computed(() => {
    if(pinSelected.value) {
        return 'background-color: #a3b3ff;'
    } else if(rowHover.value) {
         return 'background-color: #c6d2ff;'
    } else if(isSelected.value) {
        return 'background-color: #e0e7ff;'
    } else {
        return 'background-color: #f3f4f6;'
        // return 'background-color #f9fafb;'
    } 
})

const rowContentStyle = computed(() =>{
    if(pinSelected.value) {
        return 'background-color: #c6d2ff;'
    } else if(rowHover.value) {
        return 'background-color: #e0e7ff;'
    } else if(isSelected.value) {
        return 'background-color: #eef2ff;'
    } else {
        return 'background-color: white;'
    }
})

const isSelected = ref(props.selectedResultIds.includes(props.companyLocation.company.id))

watch(() => props.selectAll, () => {
    isSelected.value = props.selectAll
    if(props.selectAll) {
        emit('select-row', props.companyLocation.company)
    } else if (!props.selectAll) {
        emit('deselect-row', props.companyLocation.company)
    }
})

function toggleSelected() {
    if(isSelected.value) {
        isSelected.value = false
        emit('deselect-row', props.companyLocation.company)
    } else {
        isSelected.value = true
        emit('select-row', props.companyLocation.company)
    }
}

const companyId = computed(() => {
    // console.log(props.companyLocation)
    return props.companyLocation ? props.companyLocation.company.id : ''
})

const companyName = computed(() => {
    return props.companyLocation && props.companyLocation.company ? props.companyLocation.company.company_name : ''
})

const companyRevenue = computed(() => {
    return props.companyLocation && props.companyLocation.company  ? props.companyLocation.company.revenue : '--'
})

const companyHeadcount = computed(() => {
    return props.companyLocation && props.companyLocation.company  ? props.companyLocation.company.employee_headcount : '--'
})

const locationAddress = computed(() => {
    return props.companyLocation ? `${props.companyLocation.location.address_line_1} ${props.companyLocation.location.address_line_2 ? props.companyLocation.location.address_line_2 : '' }` : null
})

const locationCity = computed(() => {
    return props.companyLocation ? props.companyLocation.location.city : ''
})

const locationState = computed(() => {
    return props.companyLocation ? props.companyLocation.location.state : ''
})

const locationZip = computed(() => {
    return props.companyLocation ? props.companyLocation.location.zip : ''
})

const locationCountry = computed(() => {
    return props.companyLocation ? props.companyLocation.location.country : ''
})

function openCompanyModal() {
    emit('open-company-modal', props.companyLocation.company.id)
}

function selectCompanyLocation() {
    emit('select-company-location', props.companyLocation)
}

function handleRowHover() {
    rowHover.value = true
}

function handleRowLeave() {
    rowHover.value = false
}

</script>